// src/pages/micuenta/EmpleosPublicados.jsx
import { useState, useEffect, useContext } from "react";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { FaArrowLeft } from "react-icons/fa";
import "./empleospublicados.css";

function EmpleosPublicados() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  // Si el usuario no está logueado o no es empleador, se muestra un mensaje de acceso denegado
  if (!user || user.userType !== "employer") {
    return (
      <div className="register-container">
        <div className="register-card">
          <h2 className="register-title">Acceso denegado</h2>
          <p>Debes ser empleador para ver esta sección.</p>
        </div>
      </div>
    );
  }

  // Estados para filtrar y almacenar los empleos publicados
  const [searchTerm, setSearchTerm] = useState("");
  const [jobs, setJobs] = useState([]);

  // Función para limpiar "la basura": elimina empleos marcados como eliminados hace más de 30 días
  const cleanTrash = () => {
    const trash = JSON.parse(localStorage.getItem("jobsTrash")) || [];
    const now = Date.now();
    const validTrash = trash.filter(
      (job) => now - job.deletionDate < 30 * 24 * 60 * 60 * 1000
    );
    localStorage.setItem("jobsTrash", JSON.stringify(validTrash));
  };

  useEffect(() => {
    cleanTrash();
    const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
    const employerJobs = storedJobs.filter((job) => job.employerId === user.id);
    setJobs(employerJobs);
  }, [user]);

  const filteredJobs = jobs.filter((job) =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleViewDetail = (jobId) => {
    navigate(`/mi-cuenta/empleos-publicados/detalles-empleo/${jobId}`);
  };

  const handleViewCandidates = (jobId) => {
    navigate(`/mi-cuenta/candidatos?jobId=${jobId}`);
  };

  const handleEdit = (jobId) => {
    navigate(`/mi-cuenta/empleos-publicados/editar/${jobId}`);
  };

  const handleDelete = (jobId) => {
    if (
      window.confirm(
        "¿Estás seguro que deseas eliminar esta publicación?\nSi la eliminas, se moverá a la basura y se eliminará automáticamente después de 30 días.\nSi cancelas, no se realizará ninguna acción."
      )
    ) {
      const storedJobs = JSON.parse(localStorage.getItem("jobs")) || [];
      const jobToDelete = storedJobs.find((job) => job.id === jobId);
      if (jobToDelete) {
        // Agregamos la fecha de eliminación para poder limpiar luego
        jobToDelete.deletionDate = Date.now();
        const trash = JSON.parse(localStorage.getItem("jobsTrash")) || [];
        localStorage.setItem("jobsTrash", JSON.stringify([...trash, jobToDelete]));
      }
      // Eliminamos el empleo de la lista
      const updatedJobs = storedJobs.filter((job) => job.id !== jobId);
      localStorage.setItem("jobs", JSON.stringify(updatedJobs));
      setJobs((prev) => prev.filter((job) => job.id !== jobId));
      alert("Publicación eliminada y movida a la basura.");
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        {/* Botón para regresar a Mi Cuenta */}
        <button className="back-button" onClick={() => navigate("/mi-cuenta")}>
          <FaArrowLeft className="back-icon" /> Regresar a Mi Cuenta
        </button>

        <h2 className="register-title">Empleos Publicados</h2>
        <p className="subtitle">Revisa y administra tus empleos publicados</p>

        {/* Filtro por título */}
        <div className="form-group filter-group">
          <label className="filter-label">FILTROS</label>
          <div className="input-wrapper">
            <input
              type="text"
              className="form-control"
              placeholder="Buscar por título..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        {filteredJobs.length === 0 ? (
          <p>
            No hay publicaciones de empleo,{" "}
            <RouterLink to="/mi-cuenta/publicar-empleo">haz una publicación ya</RouterLink>.
          </p>
        ) : (
          <div className="jobs-list">
            {filteredJobs.map((job) => (
              <div key={job.id} className="job-card">
                <div className="job-card-row">
                  <span className="job-card-label">Empleo:</span>
                  <span className="job-card-value">{job.title}</span>
                </div>
                <div className="job-card-row">
                  <span className="job-card-label">Fecha:</span>
                  <span className="job-card-value">{job.datePosted}</span>
                </div>
                <div className="job-card-row">
                  <span className="job-card-label">Modalidad:</span>
                  <span className="job-card-value">{job.modality}</span>
                </div>
                <div className="job-card-row">
                  <span className="job-card-label">Tipo:</span>
                  <span className="job-card-value">{job.jobType}</span>
                </div>
                <div className="job-card-row">
                  <span className="job-card-label">Salario:</span>
                  <span className="job-card-value">{job.salary}</span>
                </div>
                <div className="job-card-row">
                  <span className="job-card-label">Estado:</span>
                  <span className="job-card-value">{job.status}</span>
                </div>
                <div className="job-card-actions row">
                  <div className="col-12 col-sm-auto">
                    <button
                      className="btn btn-view-detail"
                      onClick={() => handleViewDetail(job.id)}
                    >
                      Ver Completo
                    </button>
                  </div>
                  <div className="col-12 col-sm-auto">
                    <button
                      className="btn btn-view-candidates"
                      onClick={() => handleViewCandidates(job.id)}
                    >
                      Ver Candidatos
                    </button>
                  </div>
                  <div className="col-12 col-sm-auto">
                    <button
                      className="btn btn-edit"
                      onClick={() => handleEdit(job.id)}
                    >
                      Editar
                    </button>
                  </div>
                  <div className="col-12 col-sm-auto">
                    <button
                      className="btn btn-delete"
                      onClick={() => handleDelete(job.id)}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default EmpleosPublicados;